import { Component, Input } from '@angular/core';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-info',
	templateUrl: './info.component.html',
	styleUrls: ['./info.component.scss']
})
export class InfoComponent {
	@Input() title: string;
	@Input() subtext: string;
	@Input() stepIndex: number;
	@Input() stepTotal: number;
	faQuestionCircle = faQuestionCircle;

	constructor(private translate: TranslateService) {
	}
}